// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type UpdateAudioElementDurationMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  duration: PrivateSchemaTypes.Scalars['NonNegativeInt'];
}>;


export type UpdateAudioElementDurationMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { setDuration?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicElementModel' }
          & Pick<PrivateSchemaTypes.TopicElementModel, 'id'>
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type UpdateAudioElementContentMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  url: PrivateSchemaTypes.Scalars['String'];
}>;


export type UpdateAudioElementContentMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { setMp3ContentUrl?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicElementModel' }
          & Pick<PrivateSchemaTypes.TopicElementModel, 'id' | 'data' | 'content'>
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type FetchUploadCredentialsQueryVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  fileName: PrivateSchemaTypes.Scalars['String'];
}>;


export type FetchUploadCredentialsQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { uploadCredentials?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'UploadCredentials' }
          & Pick<PrivateSchemaTypes.UploadCredentials, 'filename' | 'uploadUrl' | 'params'>
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type ReplaceElementMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ReplaceElementMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { replaceElement?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type UpdateVideoElementContentMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  url: PrivateSchemaTypes.Scalars['String'];
}>;


export type UpdateVideoElementContentMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { patchContent: (
          { __typename?: 'TopicElementModel' }
          & Pick<PrivateSchemaTypes.TopicElementModel, 'id' | 'data'>
          & { documents: Array<(
            { __typename?: 'VideoDocument' }
            & Pick<PrivateSchemaTypes.VideoDocument, 'id' | 'mimeType' | 'fileUrl' | 'cdnUrl'>
          )> }
        ) }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type RequestTranscodingMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
  elementId: PrivateSchemaTypes.Scalars['PositiveInt'];
  filePath: PrivateSchemaTypes.Scalars['String'];
}>;


export type RequestTranscodingMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { draftVersion?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'TopicVersionModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicVersionModelAsEditor, 'id'>
      & { element?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'TopicElementModelAsEditor' }
        & Pick<PrivateSchemaTypes.TopicElementModelAsEditor, 'id'>
        & { requestTranscoding?: PrivateSchemaTypes.Maybe<(
          { __typename?: 'TopicElementModel' }
          & Pick<PrivateSchemaTypes.TopicElementModel, 'id' | 'data'>
        )> }
      )> }
    )> }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);


export const UpdateAudioElementDurationDocument = gql`
    mutation updateAudioElementDuration($topicId: PositiveInt!, $elementId: PositiveInt!, $duration: NonNegativeInt!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          setDuration(duration: $duration) {
            id
          }
        }
      }
    }
  }
}
    `;
export type UpdateAudioElementDurationMutationFn = Apollo.MutationFunction<UpdateAudioElementDurationMutation, UpdateAudioElementDurationMutationVariables>;

/**
 * __useUpdateAudioElementDurationMutation__
 *
 * To run a mutation, you first call `useUpdateAudioElementDurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudioElementDurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudioElementDurationMutation, { data, loading, error }] = useUpdateAudioElementDurationMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      duration: // value for 'duration'
 *   },
 * });
 */
export function useUpdateAudioElementDurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAudioElementDurationMutation, UpdateAudioElementDurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAudioElementDurationMutation, UpdateAudioElementDurationMutationVariables>(UpdateAudioElementDurationDocument, options);
      }
export type UpdateAudioElementDurationMutationHookResult = ReturnType<typeof useUpdateAudioElementDurationMutation>;
export type UpdateAudioElementDurationMutationResult = Apollo.MutationResult<UpdateAudioElementDurationMutation>;
export type UpdateAudioElementDurationMutationOptions = Apollo.BaseMutationOptions<UpdateAudioElementDurationMutation, UpdateAudioElementDurationMutationVariables>;
export const UpdateAudioElementContentDocument = gql`
    mutation updateAudioElementContent($topicId: PositiveInt!, $elementId: PositiveInt!, $url: String!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          setMp3ContentUrl(bucketPath: $url) {
            id
            data
            content
          }
        }
      }
    }
  }
}
    `;
export type UpdateAudioElementContentMutationFn = Apollo.MutationFunction<UpdateAudioElementContentMutation, UpdateAudioElementContentMutationVariables>;

/**
 * __useUpdateAudioElementContentMutation__
 *
 * To run a mutation, you first call `useUpdateAudioElementContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAudioElementContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAudioElementContentMutation, { data, loading, error }] = useUpdateAudioElementContentMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useUpdateAudioElementContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAudioElementContentMutation, UpdateAudioElementContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAudioElementContentMutation, UpdateAudioElementContentMutationVariables>(UpdateAudioElementContentDocument, options);
      }
export type UpdateAudioElementContentMutationHookResult = ReturnType<typeof useUpdateAudioElementContentMutation>;
export type UpdateAudioElementContentMutationResult = Apollo.MutationResult<UpdateAudioElementContentMutation>;
export type UpdateAudioElementContentMutationOptions = Apollo.BaseMutationOptions<UpdateAudioElementContentMutation, UpdateAudioElementContentMutationVariables>;
export const FetchUploadCredentialsDocument = gql`
    query fetchUploadCredentials($topicId: PositiveInt!, $elementId: PositiveInt!, $fileName: String!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          uploadCredentials(input: {fileName: $fileName}) {
            filename
            uploadUrl
            params
          }
        }
      }
    }
  }
}
    `;

/**
 * __useFetchUploadCredentialsQuery__
 *
 * To run a query within a React component, call `useFetchUploadCredentialsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchUploadCredentialsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchUploadCredentialsQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useFetchUploadCredentialsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchUploadCredentialsQuery, FetchUploadCredentialsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchUploadCredentialsQuery, FetchUploadCredentialsQueryVariables>(FetchUploadCredentialsDocument, options);
      }
export function useFetchUploadCredentialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchUploadCredentialsQuery, FetchUploadCredentialsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchUploadCredentialsQuery, FetchUploadCredentialsQueryVariables>(FetchUploadCredentialsDocument, options);
        }
export type FetchUploadCredentialsQueryHookResult = ReturnType<typeof useFetchUploadCredentialsQuery>;
export type FetchUploadCredentialsLazyQueryHookResult = ReturnType<typeof useFetchUploadCredentialsLazyQuery>;
export type FetchUploadCredentialsQueryResult = Apollo.QueryResult<FetchUploadCredentialsQuery, FetchUploadCredentialsQueryVariables>;
export const ReplaceElementDocument = gql`
    mutation replaceElement($topicId: PositiveInt!, $elementId: PositiveInt!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        replaceElement(id: $elementId) {
          id
        }
      }
    }
  }
}
    `;
export type ReplaceElementMutationFn = Apollo.MutationFunction<ReplaceElementMutation, ReplaceElementMutationVariables>;

/**
 * __useReplaceElementMutation__
 *
 * To run a mutation, you first call `useReplaceElementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceElementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceElementMutation, { data, loading, error }] = useReplaceElementMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *   },
 * });
 */
export function useReplaceElementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReplaceElementMutation, ReplaceElementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReplaceElementMutation, ReplaceElementMutationVariables>(ReplaceElementDocument, options);
      }
export type ReplaceElementMutationHookResult = ReturnType<typeof useReplaceElementMutation>;
export type ReplaceElementMutationResult = Apollo.MutationResult<ReplaceElementMutation>;
export type ReplaceElementMutationOptions = Apollo.BaseMutationOptions<ReplaceElementMutation, ReplaceElementMutationVariables>;
export const UpdateVideoElementContentDocument = gql`
    mutation updateVideoElementContent($topicId: PositiveInt!, $elementId: PositiveInt!, $url: String!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          patchContent(content: $url) {
            id
            data
            documents {
              id
              mimeType
              fileUrl
              cdnUrl
            }
          }
        }
      }
    }
  }
}
    `;
export type UpdateVideoElementContentMutationFn = Apollo.MutationFunction<UpdateVideoElementContentMutation, UpdateVideoElementContentMutationVariables>;

/**
 * __useUpdateVideoElementContentMutation__
 *
 * To run a mutation, you first call `useUpdateVideoElementContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVideoElementContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVideoElementContentMutation, { data, loading, error }] = useUpdateVideoElementContentMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      url: // value for 'url'
 *   },
 * });
 */
export function useUpdateVideoElementContentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateVideoElementContentMutation, UpdateVideoElementContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateVideoElementContentMutation, UpdateVideoElementContentMutationVariables>(UpdateVideoElementContentDocument, options);
      }
export type UpdateVideoElementContentMutationHookResult = ReturnType<typeof useUpdateVideoElementContentMutation>;
export type UpdateVideoElementContentMutationResult = Apollo.MutationResult<UpdateVideoElementContentMutation>;
export type UpdateVideoElementContentMutationOptions = Apollo.BaseMutationOptions<UpdateVideoElementContentMutation, UpdateVideoElementContentMutationVariables>;
export const RequestTranscodingDocument = gql`
    mutation requestTranscoding($topicId: PositiveInt!, $elementId: PositiveInt!, $filePath: String!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      draftVersion {
        id
        element(id: $elementId) {
          id
          requestTranscoding(input: {filePath: $filePath}) {
            id
            data
          }
        }
      }
    }
  }
}
    `;
export type RequestTranscodingMutationFn = Apollo.MutationFunction<RequestTranscodingMutation, RequestTranscodingMutationVariables>;

/**
 * __useRequestTranscodingMutation__
 *
 * To run a mutation, you first call `useRequestTranscodingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestTranscodingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestTranscodingMutation, { data, loading, error }] = useRequestTranscodingMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      elementId: // value for 'elementId'
 *      filePath: // value for 'filePath'
 *   },
 * });
 */
export function useRequestTranscodingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RequestTranscodingMutation, RequestTranscodingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RequestTranscodingMutation, RequestTranscodingMutationVariables>(RequestTranscodingDocument, options);
      }
export type RequestTranscodingMutationHookResult = ReturnType<typeof useRequestTranscodingMutation>;
export type RequestTranscodingMutationResult = Apollo.MutationResult<RequestTranscodingMutation>;
export type RequestTranscodingMutationOptions = Apollo.BaseMutationOptions<RequestTranscodingMutation, RequestTranscodingMutationVariables>;